var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckWobbleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#B4E3E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F0FDF9",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4623_25194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5003 23.0001L22.167 24.6667L25.917 20.9167M19.1118 16.1823C19.7817 16.1289 20.4176 15.8655 20.929 15.4296C22.1226 14.4125 23.8781 14.4125 25.0716 15.4296C25.5831 15.8655 26.219 16.1289 26.8889 16.1823C28.452 16.3071 29.6933 17.5484 29.8181 19.1116C29.8715 19.7814 30.1349 20.4173 30.5708 20.9288C31.5879 22.1224 31.5879 23.8778 30.5708 25.0714C30.1349 25.5828 29.8715 26.2187 29.8181 26.8886C29.6933 28.4518 28.452 29.6931 26.8889 29.8178C26.219 29.8713 25.5831 30.1347 25.0716 30.5706C23.8781 31.5877 22.1226 31.5877 20.929 30.5706C20.4176 30.1347 19.7817 29.8713 19.1118 29.8178C17.5486 29.6931 16.3073 28.4518 16.1826 26.8886C16.1291 26.2187 15.8657 25.5828 15.4298 25.0714C14.4127 23.8778 14.4127 22.1224 15.4298 20.9288C15.8657 20.4173 16.1291 19.7814 16.1826 19.1116C16.3073 17.5484 17.5486 16.3071 19.1118 16.1823Z",
    stroke: "#15B79E",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4623_25194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(13 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWobbleIcon);
export default __webpack_public_path__ + "static/media/check_wobble_icon.15c57ac73fc26fe3be9e36cf200a9b55.svg";
export { ForwardRef as ReactComponent };